import React from "react";
import { Spin, } from "antd";

class SmartVideoPlayer extends React.Component {
    videoRef = React.createRef();
    ffmpeg = null;
    state = {
        mode: "native",       // "native" | "transcoding" | "transcoded"
        error: null,
    };

    componentDidMount() {
        this.attachNativeListeners();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.src !== this.props.src) {
            this.setState({ mode: "native", error: null }, () => {
                this.attachNativeListeners();
            });
        }
    }

    componentWillUnmount() {
        this.detachNativeListeners();
        if (this.videoRef.current?.src?.startsWith("blob:")) {
            URL.revokeObjectURL(this.videoRef.current.src);
        }
    }

    attachNativeListeners = () => {
        const video = this.videoRef.current;
        if (!video) return;
        video.addEventListener("error", this.handleNativeError);
        video.addEventListener("ended", this.handleNativeEnded);
    };

    detachNativeListeners = () => {
        const video = this.videoRef.current;
        if (!video) return;
        video.removeEventListener("error", this.handleNativeError);
        video.removeEventListener("ended", this.handleNativeEnded);
    };

    handleNativeError = () => {
        console.warn("Native video failed to decode — falling back to transcode");
        this.startTranscode();
    };

    handleNativeEnded = () => {
        const video = this.videoRef.current;
        if (!video) return;

        const duration = video.duration;
        const playedTo = video.currentTime;

        // If the browser thinks the video ended far short of its real duration,
        // treat it as a playback failure (the "1-2 sec of an 11-15 sec clip" bug)
        if (duration && isFinite(duration) && playedTo < duration - 2) {
            console.warn(
                `Video ended early (${playedTo}s of ${duration}s) — falling back to transcode`
            );
            this.startTranscode();
        }
    };

    startTranscode = async () => {
        const { src } = this.props;
        if (!src || this.state.mode === "transcoding") return;

        this.detachNativeListeners();
        this.setState({ mode: "transcoding", error: null });

        try {
            if (!window.FFmpegWASM) {
                throw new Error("FFmpeg script not loaded");
            }

            if (!this.ffmpeg) {
                const { FFmpeg } = window.FFmpegWASM;
                this.ffmpeg = new FFmpeg();
                await this.ffmpeg.load({
                    coreURL: "/ffmpeg/ffmpeg-core.js",
                    wasmURL: "/ffmpeg/ffmpeg-core.wasm",
                });
            }

            const response = await fetch(src);
            const videoData = new Uint8Array(await response.arrayBuffer());
            await this.ffmpeg.writeFile("input.mp4", videoData);

            await this.ffmpeg.exec([
                "-i", "input.mp4",
                "-c:v", "libx264",
                "-preset", "ultrafast",
                "-crf", "26",
                "-c:a", "aac",
                "-movflags", "+faststart",
                "output.mp4",
            ]);

            const data = await this.ffmpeg.readFile("output.mp4");
            const blob = new Blob([data.buffer], { type: "video/mp4" });
            const blobUrl = URL.createObjectURL(blob);

            if (this.videoRef.current) {
                this.videoRef.current.src = blobUrl;
                this.videoRef.current.load();
                this.videoRef.current.play().catch(() => { });
            }
            this.setState({ mode: "transcoded" });
        } catch (err) {
            console.error("Transcode fallback failed", err);
            this.setState({ mode: "transcoded", error: "Playback failed" });
        }
    };

    render() {
        const { src } = this.props;
        const { mode, error } = this.state;

        return (
            <div style={{ position: "relative" }}>
                {/* {mode === "transcoding" && (
                    <div style={{ padding: 20, textAlign: "center", color: "#fff", background: "#000" }}>
                        Fixing video for playback...
                    </div>
                )} */}
                {mode === "transcoding" && (
                    <div
                        style={{
                            width: "100%",
                            height: "500px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#000",
                            gap: 12,
                        }}
                    >
                        <Spin />
                        <div style={{ color: "#fff", fontSize: "14px" }}>
                            Loading...
                        </div>
                    </div>
                )}
                {error && <div style={{ color: "red", padding: 10 }}>{error}</div>}
                <video
                    ref={this.videoRef}
                    src={mode === "native" ? src : undefined}
                    autoPlay
                    muted
                    controls
                    playsInline
                    style={{
                        width: "100%",
                        height: "500px",
                        background: "#000",
                        objectFit: "fill",
                        maxHeight: "80%",
                        display: mode === "transcoding" ? "none" : "block",
                    }}
                />
            </div>
        );
    }
}

export default SmartVideoPlayer;